<template>
  <div
    v-if="modelType"
    class="group flex h-full rounded-[12px] font-roboto text-new-black shadow-none"
  >
    <div class="flex size-full rounded-xl p-4 shadow-drop-2 max-sm:flex-col">
      <div
        class="mr-3 aspect-[140/198] max-sm:mb-4 max-sm:w-[80px] sm:w-[140px]"
      >
        <img
          v-lazy-load
          :src="getSrc"
          :alt="data?.image.alt || data?.title"
          class="size-full object-contain"
        />
      </div>
      <div class="flex flex-1 flex-col">
        <div
          v-if="categoryTitle"
          class="mb-2 w-fit rounded-md bg-[#A100090F] px-2 py-1.5 text-[12px] leading-[14px] text-specialprojectsection"
        >
          {{ scoolClass.title }} | {{ categoryTitle }}
        </div>
        <div class="mb-2 flex">
          <MainPageCardsReworkedTeacherContentSrcIcon
            :link="data.entity_source.url"
            class="mr-2 mt-[3px] size-4"
          />
          <div
            class="break-words font-roboto text-[16px] font-medium leading-[22px]"
          >
            {{ data.title }}
          </div>
        </div>
        <div v-if="data.authors.length" class="flex flex-wrap">
          <div
            v-for="(author, index) in data.authors"
            :key="author.id"
            class="mt-2 flex flex-wrap items-center font-roboto text-[14px] leading-[18px] text-[#949494]"
          >
            {{ author.fullname
            }}<template v-if="index !== data.authors.length - 1"
              >,&nbsp;</template
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
    require: true,
  },
  categoryTitle: {
    type: String,
    default: '',
  },
  scoolClass: {
    type: Object,
    default: () => ({}),
  },
});

const { isDesktop, isPad, isMobile } = useBreakpoint();

const modelType = computed(() => props.data?.model_type);

const isHiddenText = ref(false);
const wrapContentSizeRef = ref(null);
const textContentSizeRef = ref(null);

onMounted(() => {
  setTimeout(() => {
    isHiddenText.value =
      textContentSizeRef.value?.getBoundingClientRect().height >
      wrapContentSizeRef.value?.getBoundingClientRect().height;
  });
});

const getSrc = computed(() => {
  const src =
    props.priorityImage ||
    (isDesktop.value && props.data?.image?.desktop) ||
    (isPad.value && props.data?.image?.desktop) ||
    (isMobile.value && props.data?.image?.mobile) ||
    props.data?.image?.src ||
    props.data?.image?.preview ||
    props.data?.test_data?.images[0]?.src;
  return src;
});
</script>

<style scoped lang="scss">
.author {
  padding-left: 20px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: #a10009;
    left: 0;
    top: 50%;
    transform: translateY(-60%);
  }
}
</style>
